module.exports = __webpack_public_path__ + "static/media/998529.3c52aada.png";